import BasicLayout from '@/layouts/basic-layout'

const prefix = 'business-operation-statement-'
export default {
  path: '/report-center/business-operation-statement',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {cache: true, title: '业务运营报表'},
      component: () => import('@/pages/report-center/business-operation-statement/index')
    },
  ]
}
